var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor zoho-find-records" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Zoho Module Name")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type zoho module name",
                "show-attributes": false,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.module,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "module", $$v)
                },
                expression: "clone.module",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Contact Phone"),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: { placeholder: "Contact Phone", "automation-mode": "" },
            model: {
              value: _vm.clone.phone,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "phone", $$v)
              },
              expression: "clone.phone",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }